/* eslint react/no-danger: 0 */
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

export const ExperienceLinkTitle = styled.h3`
  text-transform: uppercase;
`;

export const ExperienceLinkSeparator = styled.hr`
  background: #ccc;
  border: 0;
  height: 1px;
  margin: 28px 0;
`;

export const BrandLink = styled.a`
  color: ${(props) => (props.color ? props.color : Theme.colors.green)};
`;

type ExperienceLinkProps = {
  title: string;
  subtext: string;
  url: string;
  buttonText: string;
  multiGuestTitle: string;
  multiGuestSubtext: string;
  multiGuestButtonText: string;
  multiGuestExperienceLink: boolean;
  bookingIdHash: string;
  bookingLanguage: string;
};

const ExperienceLink = ({
  title,
  subtext,
  url,
  buttonText,
  multiGuestTitle,
  multiGuestSubtext,
  multiGuestButtonText,
  multiGuestExperienceLink,
  bookingIdHash,
  bookingLanguage,
}: ExperienceLinkProps): JSX.Element => {
  const linkTitle = multiGuestExperienceLink ? multiGuestTitle : title;
  const linkSubtext = multiGuestExperienceLink ? multiGuestSubtext : subtext;
  const linkButtonText = multiGuestExperienceLink
    ? multiGuestButtonText
    : buttonText;
  const experienceLinkUrl = multiGuestExperienceLink
    ? `/guest-information/${bookingIdHash}?lang=${bookingLanguage}`
    : url;

  return (
    <>
      <ExperienceLinkSeparator />
      <ExperienceLinkTitle data-testid="experienceLink-title">
        {linkTitle}
      </ExperienceLinkTitle>
      <p
        dangerouslySetInnerHTML={{
          __html: linkSubtext.replace(/\n/g, '<br />') /* // nosemgrep */,
        }}
        data-testid="experienceLink-subtext"
      />
      <BrandLink
        href={experienceLinkUrl}
        className="ui button brand-bg"
        target="_blank"
        rel="noreferrer"
        data-testid="experienceLink-button"
      >
        <span className="label">{linkButtonText}</span>
        <span className="icon-anyfont af-arrow-right" />
      </BrandLink>
    </>
  );
};

export default ExperienceLink;
